import styled from '@emotion/styled';
import imgBC from '../../images/FAQ-bi.jpg';

export const Section = styled.div`
    background-image: url(${imgBC});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 0% 0%;
    background-attachment: fixed; 
    min-height: 100vh; 
`;

